import useRESTResource from "./useRESTResource"
import { pluralize } from "web/services/inflector"

export default function useFavourite({ subjectType, subjectId }) {
  return useRESTResource({
    path: `${pluralize(subjectType)}/${subjectId}/favourite`,
    only: ["create", "destroy"],
  })
}
